
import { defineComponent } from "vue";
import GameCard from "@/components/GameCard.vue";
import type { Game } from "@/data/games";
import IconButton from "@/components/IconButton.vue";

export default defineComponent({
  name: "GameSelection",

  components: {
    GameCard,
    IconButton,
  },

  mounted() {
    this.$store.commit("enteredRoute");
    this.$store.dispatch("getHighscores");
  },

  computed: {
    games(): Game[] {
      return this.$store.state.games;
    },
    theme() {
      return this.$store.state.theme;
    },
  },

  methods: {
    switchTheme() {
      if (this.theme === "dark") {
        this.$store.dispatch("setTheme", "light");
      } else {
        this.$store.dispatch("setTheme", "dark");
      }
    },
  },
});
